<template>
  <div>
    <el-dialog
      title="Ota项目设备与用户配置"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="confVisible"
      width="90%"
      @close="closeDialog"
    >
      <el-row :gutter="16">
        <el-col :span="12">
          <div style="margin-bottom: 10px">
            <el-input
              placeholder="请输入关键字查询"
              v-model="keyword"
              @change="iChange"
            >
              <el-select
                slot="prepend"
                v-model="selectType"
                placeholder="请选择"
                style="width: 110px"
                @change="selectChange"
              >
                <el-option label="用户" value="1"></el-option>
                <el-option label="设备" value="2"></el-option>
                <el-option label="批量设备" value="3"></el-option>
              </el-select>
              <el-button
                slot="append"
                v-if="selectType !== '3'"
                icon="el-icon-search"
                :loading="loading"
                @click="onSearch"
              ></el-button>
            </el-input>
          </div>
          <el-table
            :data="dataList"
            style="width: 100%"
            @selection-change="handleSelectionChangeL"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column prop="no" label="序号" width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="selectType === '1'"
              prop="id"
              label="用户ID"
            />
            <el-table-column
              v-if="selectType === '1'"
              prop="Mobile"
              label="手机号"
            />
            <el-table-column
              v-if="selectType === '2' || selectType === '3'"
              prop="device_id"
              label="设备号"
            />
            <el-table-column
              v-if="selectType === '2'"
              prop="coding"
              label="设备编码"
            />
            <el-table-column label="操作" width="80">
              <template slot="header">
                <el-button
                  type="text"
                  size="small"
                  v-if="multipleSelectionL.length > 0"
                  @click.native.prevent="addConfs()"
                >
                  批量添加
                </el-button>
              </template>
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  v-if="isAdded(scope.row)"
                  @click.native.prevent="addConf(scope.row)"
                >
                  添加
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12">
          <div style="margin-bottom: 10px">
            <el-autocomplete
              v-model="devType"
              :fetch-suggestions="querySearch"
              placeholder="请输入设备类型"
            >
              <template slot="prepend">设备类型：</template>
            </el-autocomplete>
          </div>
          <el-table
            :data="confList"
            style="width: 100%"
            @selection-change="handleSelectionChangeR"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column prop="no" label="序号" width="60">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="devType" label="设备类型" width="80" />
            <el-table-column label="用户ID/设备编码">
              <template slot-scope="scope">
                {{ scope.row.uid || scope.row.deviceId }}
              </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="创建时间" width="180" />
            <el-table-column label="操作" width="80">
              <template slot="header">
                <el-button
                  type="text"
                  size="small"
                  v-if="multipleSelectionR.length > 0"
                  @click.native.prevent="delConfs()"
                >
                  批量删除
                </el-button>
              </template>
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click.native.prevent="delConf(scope.row.id)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { getOtaConfList, otaConfAdd, otaConfDel } from "../../api/otaApi";
import { DeviceLists } from "../../api/device";
import { users } from "../../api/userApi";
import { handleResponse } from "../../utils/response";

export default {
  name: "OtaUserConf",
  props: {
    project: {
      type: Object,
      default: {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    project(newValue) {
      if (newValue.number) {
        // console.log(newValue.number);
        this.loadConfs();
      }
    },
    visible(val) {
      this.confVisible = val;
    },
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.selectType = "1";
      this.keyword = "";
      this.dataList = [];
      this.multipleSelectionL = [];
      // this.multipleSelectionR = [];
      this.$emit("onClose");
    },
    async loadConfs() {
      const res = await getOtaConfList(this.project.number);
      handleResponse(
        res,
        (data) => {
          this.confList = data || [];
          this.devType = this.confList[0]?.devType;
        },
        (error) => {}
      );
    },

    async delConf(id) {
      try {
        await this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        const res = await otaConfDel(id);
        handleResponse(
          res,
          (data) => {
            this.loadConfs();
          },
          (error) => {}
        );
      } catch (error) {
        console.log(error);
      }
    },
    delConfs() {
      if (this.multipleSelectionR.length) {
        this.delConf(this.multipleSelectionR.map((r) => r.id).join());
      } else {
        this.$message.warning("请选择需要删除的行！");
      }
    },
    async addConf(row, flag) {
      if (!this.devType) {
        this.$message.warning("请输入设备类型！");
        return;
      }
      const params = {
        devType: this.devType,
        proNumber: this.project.number,
      };
      if (this.selectType === "1") {
        params["uid"] = row.id + "";
      } else {
        params["deviceId"] = row.device_id;
      }
      const res = await otaConfAdd(params);
      var code = res.data.code;
      if (code === 1000) {
        if (!flag) {
          this.loadConfs();
        }
        return true;
      } else {
        return false;
      }
    },
    async addConfs() {
      if (this.multipleSelectionL.length) {
        if (!this.devType) {
          this.$message.warning("请输入设备类型！");
          return;
        }
        const errList = [];
        for (let i = 0; i < this.multipleSelectionL.length; i++) {
          const r = this.multipleSelectionL[i];
          const flag = await this.addConf(r, true);
          if (!flag) {
            errList.push(r);
          }
        }
        this.loadConfs();
        if (errList.length) {
          this.$message({
            message:
              "配置项已存在：" +
              errList.map((r) => r.device_id || r.uid).join("\n"),
            type: "error",
            duration: 10000,
          });
        }
      } else {
        this.$message.warning("请选择需要添加的行！");
      }
    },
    async onSearch() {
      this.loading = true;
      let searchApi = DeviceLists;
      const searchParams = {
        size: 30,
        page: 1,
      };
      if (this.selectType === "1") {
        searchApi = users;
        if (this.keyword) {
          searchParams["keywords"] = this.keyword;
        }
      } else {
        if (this.keyword) {
          searchParams["all_encode"] = this.keyword;
        }
      }
      const res = await searchApi(searchParams);
      handleResponse(
        res,
        (data) => {
          this.dataList = data.list || [];
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    handleSelectionChangeL(val) {
      this.multipleSelectionL = val;
    },
    handleSelectionChangeR(val) {
      this.multipleSelectionR = val;
    },
    selectChange() {
      this.keyword = "";
      this.dataList = [];
      this.multipleSelectionL = [];
    },
    isAdded(row) {
      if (this.selectType === "1") {
        return !this.confList.some((c) => c.uid === row.id + "");
      } else {
        return !this.confList.some((c) => c.deviceId === row.device_id);
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    querySearch(queryString, cb) {
      var restaurants = this.devTypes;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(
        results.map((value) => ({
          value,
        }))
      );
    },
    iChange(value) {
      if (this.selectType === "3" && value) {
        this.dataList = [
          ...value.split(/[,\s\t\n]+/).map((device_id) => ({
            device_id,
          })),
        ];
      }
    },
  },

  data() {
    return {
      confVisible: false,
      confList: [],
      devType: "",
      devTypes: ["S3", "Y003", "K300", "Y0070", "Y0071", "Y0072", "Y006"],
      keyword: "",
      selectType: "1",
      dataList: [],
      loading: false,
      multipleSelectionL: [],
      multipleSelectionR: [],
    };
  },
};
</script>

<style scoped></style>
